import DesignTokens from '@tableau/design-tokens';
import { ButtonType, ButtonWidget, TabStyles } from '@tableau/widgets';
import React from 'react';
import { style } from 'typestyle';
import _ from 'underscore';

import { Messages } from '~src/codegen/Localize';
import { openReactActionDialog } from '~src/commonInfra/dialogs/ReactActionDialog';
import { TabDialogWidth } from '~src/commonInfra/dialogs/style/TabDialogWidth';
import { ToasterService,ToastType } from '~src/commonInfra/services/ToasterService';
import { CommonStyles } from '~src/commonInfra/styles/CommonStyles';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { SettingsStyles } from '~src/settings/styles/CommonStyles';
import { cssClass } from '~src/style';
import { applyColor }from '~src/style/ColorService';

import { IGetDockerRegistryResult } from '../../serverApi/requests/GetDockerRegistryRequest';
import { BaasEdgePoolAndCluster } from '../../serverApi/resources/BaasEdgePoolAndCluster';
import { ActionItemInfo } from '../MoreActionsMenu';
import { getGeneralErrorMessage } from '../utils/EdgePoolErrorUtilities';

export type GetDockerRegistryDialogProps = Readonly<{
  isDockerRegistryReady: boolean;
  description: string;
  dockerRegistryURL: string;
  username: string;
  password: string;
  passValue: string;
}>

export function openGetDockerRegistryDialog(actionItem: ActionItemInfo) {
  const {clusterId } = actionItem;

  BaasEdgePoolAndCluster.getDockerRegistry({clusterId: clusterId})
      .then((result: IGetDockerRegistryResult) => {
        if (result.success) {
          const {dockerRepository, loginName, password} = result.success;
          const dialogInstance = openReactActionDialog({
            title: Messages.dataConnectSiteSettingsGetDockerRegistryButton(),
            bodyComponent: GetDockerRegistryDialogBody,
            initialBodyProps: {
            isDockerRegistryReady: !_.isEmpty(dockerRepository),
            description: _.isEmpty(dockerRepository)? Messages.dataConnectSiteSettingsGetDockerRegistryDescriptionNotReady()
            : Messages.dataConnectSiteSettingsGetDockerRegistryDescription(),
            dockerRegistryURL: Messages.dataConnectSiteSettingsGetDockerRegistryURL({ URL: dockerRepository }),
            username: Messages.dataConnectSiteSettingsGetDockerRegistryUsername({ USERNAME: loginName }),
            password: Messages.dataConnectSiteSettingsGetDockerRegistryPassword({ PASSWORD: '******************' }),
            passValue: password
           },
            initialDialogState: { hasError: false },
            actionName: Messages.close(),
            action: () => {
              return Promise.resolve({});
            },
            dismissDialogOnActionFailed: true,
            dialogWidth: TabDialogWidth.width500px,
            hideCancelButton: true,
          });
          return Promise.resolve(dialogInstance.result);
        }
        if (result.errors) {
          ToasterService.instance.pop({
            type: ToastType.Error,
            text: getGeneralErrorMessage(result.errors[0].code, result.errors[0].message)
          });
        }
      });
}

export function GetDockerRegistryDialogBody(props: GetDockerRegistryDialogProps) {

  const descriptionDivClassName = `${SettingsStyles.settingsGroupDescription}`;

  const copyCode = ()=>{
    const code = document.getElementById('docker-registry-code-block').innerText.replace('******************', props.passValue);

    navigator.clipboard.writeText(code);
    ToasterService.instance.pop({ type: ToastType.Success, text: Messages.dataConnectSiteSettingsGetDockerRegistryScriptCopied() });
  };
  const {isDockerRegistryReady} = props;
  return (
    <div className={fieldClass}>
      <div className={descriptionDivClassName} style={{marginTop: 10}}  data-tb-test-id={'docker-registry-text-details'}>
                <span>
                  {props.description}
                </span>
                {
                isDockerRegistryReady && <>
                <div className={container} >
                  <div className={codeContainer}>
                          <code id={'docker-registry-code-block'} >
                            <span className={cammandLIneClass}>
                              {props.dockerRegistryURL}
                            </span>
                            <span className={cammandLIneWithMarginClass}>
                              {props.username}
                            </span>
                            <span className={cammandLIneWithMarginClass}>
                              {props.password}
                            </span>
                          </code>
                  </div>
                  <div className={buttonContainer}>
                      <ButtonWidget
                          testId={'copy-code-btn'} buttonType={ButtonType.Outline}
                          tabIndex={-1}
                          onClick={copyCode}
                          className={copyBtn}
                          style={{}}
                        >
                          <img src={imgPath('copy_paste_14px-small.svg')} alt={ Messages.dataConnectSiteSettingsGetDockerRegistryCopyPasteButton()} className={copyBtnIconClass}/>
                      </ButtonWidget>
                  </div>
                </div>
                </>
                }
      </div>
    </div>
  );
}

const fieldClass = style({ marginBottom: TabStyles.Sizing.BaseUnit * 5 });

const cammandLIneClass = style({  display: 'block'});
const cammandLIneWithMarginClass = style({     marginTop: '16px', display: 'block' });


export const errorClass = style({ marginTop: TabStyles.Spacing.DefaultSpace, color: applyColor(DesignTokens.color.font.default.error, TabStyles.Colors.AttentionDark) });

const container = style({
  display: 'flex',
  marginTop: 10,
  backgroundColor: applyColor(DesignTokens.color.component.background.neutral.default.active, CommonStyles.Colors.Grey230),
  boxShadow: '0 4px 8px '+ applyColor(DesignTokens.color.elevation.surface.default.default, 'rgba(0, 0, 0, 0.1)'),
  position: 'relative',
});

const codeContainer = style({
  verticalAlign: 'top',
  textAlign: 'left',
  paddingTop: 16,
  paddingBottom: 16,
  paddingLeft: 16,
 });

const buttonContainer = style({
  width: 30,
  verticalAlign: 'top',
  position: 'relative',

 });

 const copyBtn = style({
  padding: 0,
  position: 'absolute',
  top: 8,
  right: 8,
  borderWidth: 1,
  borderRadius: 3,
  borderColor: applyColor(DesignTokens.color.component.border.neutral.default.default, CommonStyles.Colors.Grey40),
  transition:'background-color 0.3s',
  minWidth: 30,
  minHeight: 24
 });

 const copyBtnIconClass = cssClass('copy-code', 'icon', {
  verticalAlign: 'middle',
});
